import React, { FC } from 'react';
import {
  StyledCloseButton,
  StyledCloseIcon,
  StyledCloudImage,
  StyledContentContainer,
  StyledContentWrapper,
  StyledEyebrow,
  StyledFlex,
  StyledHeadWrapper,
  StyledStep,
  StyledTitle,
} from './FeatureCard.styles';
import { Text } from '@components/typography';

interface FeatureCardProps {
  step: number;
  imageUrl: string;
  eyebrow: string;
  title: string;
  onClose: () => void;
  id: string;
}

export const FeatureCard: FC<FeatureCardProps> = (props) => {
  const { id, step, imageUrl, eyebrow, title, onClose } = props;
  return (
    <StyledFlex>
      <StyledCloseButton id={`${id}-modal-close`} variant="altPurpleSecondary" onClick={onClose}>
        <StyledCloseIcon name="notAttending" color="mono1" />
      </StyledCloseButton>
      <StyledContentContainer>
        <StyledCloudImage src={imageUrl} alt={title} optimization="default" />
        <StyledContentWrapper>
          <StyledHeadWrapper>
            <StyledStep>
              <Text variant="dek24" tagName="span" color="white">
                {step}
              </Text>
            </StyledStep>
            <StyledEyebrow tagName="p" variant="featureCopy17" color="accentBlue4">
              {eyebrow}
            </StyledEyebrow>
          </StyledHeadWrapper>
          <StyledTitle tagName="p" variant="calloutHed32" color="mono1">
            {title}
          </StyledTitle>
        </StyledContentWrapper>
      </StyledContentContainer>
    </StyledFlex>
  );
};
